import React from 'react';
import videoback from '../vids/video1.webm';
const VideoBackground = () => {
  return (
    <video
      autoPlay
      loop
      muted
      style={{
        position: 'flex',
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        zIndex: -1
      }}
    >
      <source src={videoback} type="video/webm" />
    </video>
  );
};
export default VideoBackground;